import { render, staticRenderFns } from "./Movimentazioni.vue?vue&type=template&id=e634c068&"
import script from "./Movimentazioni.vue?vue&type=script&lang=js&"
export * from "./Movimentazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports